module.exports = __webpack_public_path__ + "img/du_uae.86301dea.png";